// Разворот линии редактора маршрутов: старт и финиш меняются местами.
// Вершины идут в обратном порядке, леги тоже, а геометрия каждого лега
// разворачивается как есть (граф троп ненаправленный - трасса не
// перестраивается). Вход не мутируется.
export type Coordinate = [number, number];

export interface ReversibleLeg {
  geometry: Coordinate[];
}

export const reverseLine = <L extends ReversibleLeg>(
  vertices: Coordinate[],
  legs: L[]
): { vertices: Coordinate[]; legs: L[] } => ({
  vertices: vertices.slice().reverse(),
  legs: legs
    .slice()
    .reverse()
    .map((leg) => ({ ...leg, geometry: leg.geometry.slice().reverse() })),
});
